"use client";

import { createContext, useContext, type ReactNode } from "react";

type WorkspaceRouteNamespace = {
  /** Null only while the server is resolving the route, never an ambient fallback. */
  namespaceId: string | null;
  slug: string;
};

const WorkspaceRouteContext = createContext<WorkspaceRouteNamespace | null>(null);

export function WorkspaceRouteProvider({ children, ...namespace }: WorkspaceRouteNamespace & { children: ReactNode }) {
  return <WorkspaceRouteContext.Provider value={namespace}>{children}</WorkspaceRouteContext.Provider>;
}

/** Absent only for unscoped routes and full-shell previews. */
export function useWorkspaceRouteNamespace() {
  return useContext(WorkspaceRouteContext);
}
